import React, { useState } from "react";
import PropTypes from "prop-types";
import Truncate from "react-truncate";
import { Button } from "@mui/material";

import useStyles from "./useStyles";

const ReadMore = ({ children, lines, less, more }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [truncated, setTruncated] = useState(false);

  const handleTruncate = (truncate) => {
    setTruncated(truncate);
  };

  const toggleLines = (event) => {
    event.preventDefault();

    setExpanded(!expanded);
  };

  return (
    <div>
      <Truncate
        lines={!expanded && lines}
        ellipsis={
          <span>
            ...{" "}
            <Button className={classes.button} color="secondary" onClick={toggleLines}>
              {more}
            </Button>
          </span>
        }
        onTruncate={handleTruncate}
        className={truncated && !expanded ? classes.wrapper : ""}
      >
        {children}
      </Truncate>
      {!truncated && expanded && (
        <span>
          {" "}
          <Button className={classes.button} color="secondary" onClick={toggleLines}>
            {less}
          </Button>
        </span>
      )}
    </div>
  );
};

ReadMore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  less: PropTypes.string,
  more: PropTypes.string,
};

ReadMore.defaultProps = {
  lines: 2,
  more: "More",
  less: "Less",
};

export default ReadMore;
